export const user = {
  SET_USER: 'user/SET_USER',
  UPDATE_USER: 'user/UPDATE_USER',
  DISMISS_NOTIFICATION: 'notification/DISMISS_NOTIFICATION',
  DISMISS_ALL_NOTIFICATIONS: 'notification/DISMISS_ALL_NOTIFICATIONS',
  SET_NOTIFICATIONS: 'notifications/SET_NOTIFICATIONS',
  SET_USER_BOARDS: 'user/SET_USER_BOARDS',
  SET_USER_NETWORKS: 'user/SET_USER_NETWORKS',
  ADD_USER_EMAIL: 'user/ADD_USER_EMAIL',
  REMOVE_USER_EMAIL: 'user/REMOVE_USER_EMAIL',
  SET_USER_PRIMARY_EMAIL: 'user/SET_USER_PRIMARY_EMAIL'
}
export const group = {
  SET_GROUPS: 'group/SET_GROUP',
  SET_EDITORS: 'group/SET_EDITORS',
  UPDATE_EDITORS: 'group/UPDATE_EDITORS'
}
export const board = {
  SET_BOARD: 'board/SET_BOARD',
  SET_BOARD_FEATURES: 'board/SET_BOARD_FEATURES',
  SET_BOARD_GROUPS: 'board/SET_BOARD_GROUPS',
  ADD_BOARD_SHARE_TOKEN: 'board/ADD_BOARD_SHARE_TOKEN',
  TOGGLE_BOARD_SHARE_TOKEN: 'board/TOGGLE_BOARD_SHARE_TOKEN',
  UPDATE_GROUP_NAME: 'board/UPDATE_GROUP_NAME',
  SET_FEED: 'board/SET_FEED',
  APPEND_FEED: 'board/APPEND_FEED',
  ADD_POST: 'board/ADD_POST',
  UPDATE_POST: 'board/UPDATE_POST',
  SET_PINNED_POST: 'board/SET_PINNED_POST',
  SET_FEED_LENGTH: 'board/SET_FEED_LENGTH',
  SET_FEED_COLLAPSED: 'board/SET_FEED_COLLAPSED',
  ADD_ADMIN: 'board/ADD_ADMIN',
  REMOVE_ADMIN: 'board/REMOVE_ADMIN',
  REMOVE_FOLLOWER: 'board/REMOVE_FOLLOWER',
  CREATE_OR_REMOVE_REACTION: 'board/CREATE_OR_REMOVE_REACTION',
  ADD_VOTE: 'board/ADD_VOTE',
  RETRACT_VOTE: 'board/RETRACT_VOTE',
  SET_DATERANGE: 'board/SET_DATERANGE',
  SET_DASHBOARD: 'board/SET_DASHBOARD',
  REMOVE_DASHBOARD_LABEL: 'board/REMOVE_DASHBOARD_LABEL',
  SET_EMOJI: 'board/SET_EMOJI',
  REMOVE_EMOJI: 'board/REMOVE_EMOJI',
  REMOVE_ALL_EMOJIS: 'board/REMOVE_ALL_EMOJIS',
  REMOVE_TOPIC: 'board/REMOVE_TOPIC',
  UPSERT_TOPIC: 'board/UPSERT_TOPIC',
  REMOVE_BADGE: 'board/REMOVE_BADGE',
  UPSERT_BADGE: 'board/UPSERT_BADGE',
  REMOVE_POST_BADGE: 'post/REMOVE_POST_BADGE',
  ADD_POST_BADGE: 'post/ADD_POST_BADGE',
  ADD_READ_FLAG: 'post/ADD_READ_FLAG',
  ADD_COMMENT_READ_FLAG: 'post/ADD_COMMENT_READ_FLAG',
  SET_CONFIG: 'board/SET_CONFIG',
  SET_NEW_POSTS: 'board/SET_NEW_POSTS',
  ADD_ACTIVITIES: 'board/ADD_ACTIVITIES',
  SET_ACTIVITIES_TX: 'board/SET_ACTIVITIES_TX',
  SET_CONTROLS_IN_VIEW: 'board/SET_CONTROLS_IN_VIEW',
  SET_DISABLED_EMOJIS: 'board/SET_DISABLED_EMOJIS',
  UPDATE_POINT_METRICS: 'board/UPDATE_POINT_METRICS',
  SET_BOARD_COMMENT: 'board/SET_BOARD_COMMENT',
  UPDATE_BOARD_COMMENT: 'board/UPDATE_BOARD_COMMENT',
  UPDATE_FOLLOWERS_POINTS: 'board/UPDATE_FOLLOWERS_POINTS',
  SET_POST_VIEW: 'board/SET_POST_VIEW',
  SET_PINNED_POST_VIEW: 'board/SET_PINNED_POST_VIEW',
  SET_FEED_SCROLLING: 'board/SET_FEED_SCROLLING',
  REMOVE_POST_IN_VIEW: 'board/REMOVE_POST_IN_VIEW',
  SET_POST_QUERY: 'board/SET_POST_QUERY',
  SET_MEMBERS: 'board/SET_MEMBERS',
  SET_NUDGE_SETTINGS: 'board/SET_NUDGE_SETTINGS',
  SET_DID_TOTAL_MEMBERS_SURPASS_CUTOFF_SIZE:
    'board/SET_DID_TOTAL_MEMBERS_SURPASS_CUTOFF_SIZE'
}
export const boards = {
  SET_BOARDS: 'boards/SET_BOARDS',
  SET_SORT_TYPE: 'boards/SET_SORT_TYPE',
  SET_SEARCH_TEXT: 'boards/SET_SEARCH_TEXT',
  SET_LOADING: 'boards/SET_LOADING'
}
export const collection = {
  SET_FETCHING: 'collection/SET_FETCHING',
  SET_FILTERS: 'collection/SET_FILTERS',
  SET_FILTER: 'collection/SET_FILTER',
  SET_PAGE: 'collection/SET_PAGE',
  SET_PER_PAGE: 'collection/SET_PER_PAGE',
  SET_SORT: 'collection/SET_SORT',
  SET_ASOF: 'collection/SET_ASOF',
  SET_LAST_FETCHED_STATE: 'collection/SET_LAST_FETCHED_STATE'
}
export const conversations = {
  UPDATE_MESSAGES: 'conversations/UPDATE_MESSAGES',
  UPDATE_CONVERSATIONS: 'conversations/UPDATE_CONVERSATIONS',
  SET_SELECTED_THREAD: 'conversations/SET_SELECTED_THREAD'
}
export const modal = {
  SET_MODAL: 'modal/SET_MODAL'
}
export const network = {
  SET_NETWORK: 'network/SET_NETWORK',
  SET_MEMBERS: 'network/SET_MEMBERS',
  SET_MEMBER_COUNT: 'network/SET_MEMBER_COUNT',
  ADD_ACTIVITIES: 'network/ADD_ACTIVITIES',
  SET_NETWORK_BOARDS: 'network/SET_NETWORK_BOARDS',
  SET_NETWORK_BOARD_COUNT: 'network/SET_NETWORK_BOARD_COUNT',
  SET_NETWORK_PENDING_BOARDS: 'network/SET_NETWORK_PENDING_BOARDS'
}
export const banner = {
  SET_BANNER: 'banner/SET_BANNER'
}
export const profile = {
  SET_PROFILE: 'profile/SET_PROFILE'
}
export const dataTable = {
  SET_SORT_BY: 'dataTable/SET_SORT_BY',
  TOGGLE_SORT_ASC: 'dataTable/TOGGLE_SORT_ASC',
  RESET_SORT_ASC: 'dataTable/RESET_SORT_ASC',
  SET_PAGE: 'dataTable/SET_PAGE'
}
export const emoji = {
  MAKE_REQUEST: 'emoji/MAKE_REQUEST',
  INVALIDATE_DATA: 'emoji/INVALIDATE_DATA',
  RECEIVE_DATA: 'emoji/RECEIVE_DATA'
}
export const admin = {
  UPDATE_TX_LOG: 'admin/UPDATE_TX_LOG'
}
export const lti = {
  SET_LTI: 'lti/SET_LTI'
}
